module.exports = __webpack_public_path__ + "static/media/variant.1e9b7c22.svg";